import { scrollToTargetCenter } from '../../../../../utils/scroll.ts';

export const stickyMenuAutoFocus = (container: HTMLDivElement) => {
  return new IntersectionObserver(
    items => {
      items.forEach(item => {
        const categoryElementUnderline = document.querySelector(`a[href="#${item.target.id}"]>div`);
        if (item.isIntersecting) {
          const menuCategories = container?.querySelector('div');
          const categoryElement = document.querySelector(`a[href="#${item.target.id}"]`);

          categoryElementUnderline?.classList.remove('hidden');
          if (categoryElement && menuCategories) {
            scrollToTargetCenter(categoryElement as HTMLElement, menuCategories as HTMLElement);
          }
        } else {
          categoryElementUnderline?.classList.add('hidden');
        }
      });
    },
    { root: null, rootMargin: '0px', threshold: 0.1 }
  );
};
